import React from 'react';
import './HierarchyTree.css';

const ProfileCard = ({ person }) => {
  return (
    <div className="profile-card">
      <div className="image-container">
        <img src={person.image} alt={person.name} className="profile-image" />
      </div>
      <div className="card-content">
        <h3 className="person-name">{person.name}</h3>
        <p className="person-role">{person.designation}</p>
        <div className="person-quote-wrapper">
          {person.quote && <p className="person-quote">"{person.quote}"</p>}
        </div>
      </div>
    </div>
  );
};

const HierarchyNode = ({ node }) => {
  if (!node) return null;
  
  return (
    <div className="hierarchy-node">
      <div className="node-parent">
        <ProfileCard person={node} />
      </div>
      {node.children && node.children.length > 0 && (
        <div className="node-children">
          {node.children.map((child, index) => (
             <HierarchyNode key={`${child.id || index}`} node={child} />
          ))}
        </div>
      )}
    </div>
  );
};

const HierarchyTree = ({ data, title, subtitle }) => {
  return (
    <div className="hierarchy-container">
      <div className="container text-center pt-5 pb-5">
        <div className="pb-4">
            <p className="section-title px-5">
              <span className="px-2">{subtitle || "Leadership"}</span>
            </p>
            <h1 className="mb-4">{title ? title : "Meet Our Leadership"}</h1>
        </div>
        <div className="hierarchy-wrapper">
          <HierarchyNode node={data} />
        </div>
      </div>
    </div>
  );
};

export default HierarchyTree;
